import React from "react";
import { Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AssignmentIcon from "@mui/icons-material/Assignment";
import BusinessIcon from "@mui/icons-material/Business";
import PersonIcon from "@mui/icons-material/Person";
import ExitToAppIcon from "@mui/icons-material/ExitToApp"; // Logout Icon
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom"; // ✅ Add `useNavigate`
import { getAuth, signOut, onAuthStateChanged } from "firebase/auth"; // Firebase Auth Import
import { useState, useEffect } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";

import ListAltIcon from "@mui/icons-material/ListAlt"; // 👈 icon for Activity Log

import { collection, query, where, getDocs } from "firebase/firestore";

import { Divider, Box, Typography, Switch } from "@mui/material";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn"; // logo badge (any icon is fine)

import { getFirestore, doc, getDoc } from "firebase/firestore";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
 import Badge from "@mui/material/Badge";
 import { onSnapshot } from "firebase/firestore";

import NotificationsPanel from "./NotificationsPanel";

import MenuBookIcon from "@mui/icons-material/MenuBook";

import AssessmentIcon from "@mui/icons-material/Assessment";


const Sidebar = () => {
  
  const navigate = useNavigate();
  const location = useLocation();
  const auth = getAuth(); // Get Firebase Auth instance
  const [user, setUser] = useState(null);

  const [role, setRole] = useState(null);

  const [open, setOpen] = useState(false);
  const [unread, setUnread] = useState(0);   // ✅ add this

  const [notifOpen, setNotifOpen] = useState(false);   // ← new


  const toggleDrawer = () => setOpen(!open);



  // Listen for authentication state changes
useEffect(() => {
  const db = getFirestore();

  const un = onAuthStateChanged(auth, async (currentUser) => {
    setUser(currentUser);

    if (!currentUser) {
      setRole(null);
      return;
    }

    try {
      let r = "";

      // 1) Try users/{uid}
      const byUid = await getDoc(doc(db, "users", currentUser.uid));
      if (byUid.exists()) {
        r = (byUid.data()?.role || "").toLowerCase();
      }

      // 2) Fallback: users where email == currentUser.email
      if (!r && currentUser.email) {
        const q = query(collection(db, "users"), where("email", "==", currentUser.email));
        const qs = await getDocs(q);
        if (!qs.empty) r = (qs.docs[0].data()?.role || "").toLowerCase();
      }

      setRole(r || "member"); // safe default
    } catch (e) {
      console.error("Failed to load user role:", e);
      setRole("member");
    }
  });

  return () => un();
}, [auth]);


  // Logout Function
  const handleLogout = async () => {
    try {
      await signOut(auth); // Firebase sign-out
      navigate("/login"); // Redirect to login page
    } catch (error) {
      console.error("Logout Error:", error);
    }
  };
  
const r = (role || "").toLowerCase();
const isAdmin = r.trim() === "admin"; // admin only (not manager/super)
const isAdminOrManager = r.includes("admin") || r.includes("manager") || r.includes("super");
const isMember = !isAdminOrManager;

const DASHBOARD = { text: "Dashboard", icon: <DashboardIcon />, path: "/dashboard" };
const ENTITIES  = { text: "Entities",  icon: <BusinessIcon />,   path: "/entities"  };
const PROJECTS  = { text: "Projects",  icon: <AssignmentIcon />, path: "/projects"  };
const TASKS     = { text: "Tasks",     icon: <AssignmentIcon />, path: "/tasks"     };
const ACTIVITY  = { text: "Activity Log", icon: <ListAltIcon />, path: "/activity-log" };
const USERS     = { text: "Users", icon: <PersonIcon />, path: "/users" };

  const TIMESHEET = { text: "Timesheet", icon: <AccessTimeIcon />, path: "/timesheet" };
  
  const PROFILE = { text: "Profile", icon: <PersonIcon />, path: "/profile" };

const RESOURCES = { text: "Resources", icon: <MenuBookIcon />, path: "/resources" };
const REPORTS_EXPORT = { text: "Reports Export", icon: <AssessmentIcon />, path: "/reports-export" };

const menuItems = isAdminOrManager
  ? [DASHBOARD, ENTITIES, PROJECTS, TASKS, REPORTS_EXPORT,TIMESHEET, ACTIVITY, USERS, RESOURCES, ...(isAdmin ? [PROFILE] : [])]
  : [DASHBOARD, TASKS, REPORTS_EXPORT,TIMESHEET, ACTIVITY, RESOURCES];


// Show "Users" only for Super Admin and Team Manager

 useEffect(() => {
  const db = getFirestore();
  if (!user) { setUnread(0); return; }
  const q = query(
    collection(db, "users", user.uid, "notifications"),
    where("read", "==", false)
  );
  const unsub = onSnapshot(q, (snap) => setUnread(snap.size));
  return () => unsub();
 }, [user]);


  
// Hide sidebar on login and signup pages
if (!user && (location.pathname === "/" || location.pathname === "/login" || location.pathname === "/signup")) {
  return null;
}


  return (
    <>
  {/* Hamburger Menu Button */}
  <IconButton
    onClick={toggleDrawer}
    sx={{ position: "fixed", top: 16, left: 16, zIndex: 1300 }}
  >
    <MenuIcon />
  </IconButton>

  <Drawer
  variant="temporary"
  open={open}
  onClose={toggleDrawer}
  ModalProps={{ keepMounted: true }}
  PaperProps={{
    sx: {
      width: 280,
      bgcolor: "#00509d",          // dark indigo
      color: "#ffff",
      borderRadius: 4,              // 32px
      m: 2,                         // margin so it looks like a floating card
      height: "calc(100% - 32px)",
      boxShadow: "0 12px 40px rgba(0,0,0,.25)",
      overflow: "hidden",
    },
  }}
>
  {/* Brand header */}
  <Box sx={{ p: 2.5, display: "flex", alignItems: "center", gap: 1.5 }}>
    <Box
      sx={{
        width: 56,
        height: 56,
        borderRadius: "50%",
        bgcolor: "rgba(255,255,255,.15)",
        display: "grid",
        placeItems: "center",
      }}
    >
      <AssignmentTurnedInIcon />
    </Box>
    <Typography variant="h6" sx={{ fontWeight: 800, flex: 1, letterSpacing: .2 }}>
      WorkPulse.in
    </Typography>
    
    <IconButton onClick={() => navigate("/notifications")} sx={{ color: "#fff" }}>
      <Badge color="error" badgeContent={unread} max={99} overlap="circular">
        <NotificationsNoneIcon />
      </Badge>
    </IconButton>

  </Box>

  <Divider sx={{ borderColor: "rgba(255,255,255,.12)" }} />

  {/* Menu */}
  <List sx={{ px: 1.5, py: 1 }}>
    {menuItems.map((item) => {
      const active = location.pathname.startsWith(item.path);
      return (
        <ListItem key={item.text} disablePadding sx={{ mb: 0.5 }}>
          <ListItemButton
            component={Link}
            to={item.path}
            onClick={toggleDrawer}
            sx={{
              borderRadius: 2,
              color: "#ffffff",
              "& .MuiListItemIcon-root": { color: "inherit", minWidth: 36 },
              ...(active && { bgcolor: "rgba(255,255,255,.14)" }),
              "&:hover": { bgcolor: "rgba(255,255,255,.10)" },
            }}
          >
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText
              primary={item.text}
              primaryTypographyProps={{ fontWeight: active ? 600 : 500 }}
            />
          </ListItemButton>
        </ListItem>
      );
    })}
  </List>

  {/* Footer: toggles + logout */}
  <Box sx={{ mt: "auto", p: 2 }}>
    <Divider sx={{ mb: 2, borderColor: "rgba(255,255,255,.12)" }} />
    

    <ListItem disablePadding sx={{ mt: 1 }}>
      <ListItemButton
        onClick={handleLogout}
        sx={{
          borderRadius: 2,
          color: "#FF7A7A",
          "& .MuiListItemIcon-root": { color: "#FF7A7A" },
          "&:hover": { bgcolor: "rgba(255,255,255,.10)" },
        }}
      >
        <ListItemIcon>
          <ExitToAppIcon />
        </ListItemIcon>
        <ListItemText primary="Logout" />
      </ListItemButton>
    </ListItem>
  </Box>
</Drawer>

{/* Right-side notifications drawer */}
<Drawer
  anchor="right"
  open={notifOpen}
  onClose={() => setNotifOpen(false)}
  PaperProps={{ sx: { width: 380 } }}
>
  <NotificationsPanel open={notifOpen} onClose={() => setNotifOpen(false)} />
</Drawer>

</>

  );
};

export default Sidebar;
